<template>
    <div  class="client-tabs">
        <button v-for="(client, idx) in appointment.clients"
            @click.prevent="showClientIndex(idx)"
            :key="client.id"
            :class="{'active' : idx == clientindex}">
            {{client.firstname}}
        </button>
    </div>
</template>

<script>
export default {
    name : "ClientNamesTabs",
    props: {
        appointment: {
            type: Object
        },
        clientindex : {
            type: Number
        }
    },

    computed: {
        getCurrentClientIndex: {
            get() {
                return this.currentClientIndex;
            },

            set(value) {
                this.$emit("update:clientindex", value);
            }
        }
    },

    methods: {
        showClientIndex(idx) {
            this.getCurrentClientIndex = idx;
        }
    }
};
</script>

<style lang="scss" scoped>
    .client-tabs {
        margin: 20px;
        position: absolute;
        top: 0;
        width: 40vw;
        left: 50%;
        margin-left: -20vw;
        display: flex;
        justify-content: space-evenly;

        button {
            @extend .reset-btn;
            position: relative;
            font-size : 1.5rem;
            display : inline-block;
            line-height:1.2rem;

            &:before {
                content: ' ';
                position: absolute;
                background-image: url('/img/header-lines.svg');
                background-repeat: no-repeat;
                background-size: 100%;
                width: 3em;
                height: 1.2em;
                left: -4.5rem;
                top: 0.25em
            }

            &.active {
                font-weight: bold;

                &:after {
                    content: ' ';
                    width: 60%;
                    height: .2rem;
                    background: #1A1E57;
                    display: block;
                    left: 12.5%;
                    position: absolute;
                    top: 1.25em;
                }
            }
        }
    }
</style>